<template>
  <div class="goods-category">
    <div class="goods-category-body">
      <!-- carousel -->
      <div class="carousel">
        <div class="carousel-wrapper">
          <a
            class="carousel-item-img"
            style="background-image:url(https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=3663359702,1992818410&fm=26&gp=0.jpg);"
          >
            <!-- <div class="carousel-item-name">【斯里兰卡】春节中南部深度游</div> -->
          </a>
        </div>
      </div>

      <div class="category">
        <div
          class="category-list"
          v-for="(category, index) in category"
          :key="index"
        >
          <div class="category-title">{{ category.cate_name }}</div>
          <div class="category-content">
            <div
              class="category-item-list pull-left"
              v-for="(children, cindex) in category.children"
              :key="cindex"
            >
              <router-link
                class="category-item-link"
                :to="{
                  name: 'CityActivities',
                  query: {
                    cate_id: children.id,
                    type: 'other',
                    other_type: '',
                    parent_id: category.id
                  }
                }"
              >
                <div class="category-item-img-wrapper">
                  <img class="category-item-img" v-lazy="children.pic" />
                </div>
                <div class="category-item-title">{{ children.cate_name }}</div>
              </router-link>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>

        <div class="category-list">
          <div class="category-title">时间跨度</div>
          <div class="category-content">
            <div class="category-item-list pull-left">
              <router-link
                class="category-item-link"
                :to="{
                  name: 'CityActivities',
                  query: {
                    cate_id: '',
                    type: 'other',
                    other_type: 'time',
                    days: 1
                  }
                }"
              >
                <div class="category-item-img-wrapper">
                  <img
                    class="category-item-img"
                    src="../../assets/images/day1_5.png"
                  />
                </div>
                <div class="category-item-title">1天</div>
              </router-link>
            </div>
            <div class="category-item-list pull-left">
              <router-link
                class="category-item-link"
                :to="{
                  name: 'CityActivities',
                  query: {
                    cate_id: '',
                    type: 'other',
                    other_type: 'time',
                    days: 2
                  }
                }"
              >
                <div class="category-item-img-wrapper">
                  <img
                    class="category-item-img"
                    src="../../assets/images/day2_5.png"
                  />
                </div>
                <div class="category-item-title">2天</div>
              </router-link>
            </div>
            <div class="category-item-list pull-left">
              <router-link
                class="category-item-link"
                :to="{
                  name: 'CityActivities',
                  query: {
                    cate_id: '',
                    type: 'other',
                    other_type: 'time',
                    days: 3
                  }
                }"
              >
                <div class="category-item-img-wrapper">
                  <img
                    class="category-item-img"
                    src="../../assets/images/day3_5.png"
                  />
                </div>
                <div class="category-item-title">3天</div>
              </router-link>
            </div>
            <div class="category-item-list pull-left">
              <router-link
                class="category-item-link"
                :to="{
                  name: 'CityActivities',
                  query: {
                    cate_id: '',
                    type: 'other',
                    other_type: 'time',
                    days: 6
                  }
                }"
              >
                <div class="category-item-img-wrapper">
                  <img
                    class="category-item-img"
                    src="../../assets/images/day4_5.png"
                  />
                </div>
                <div class="category-item-title">4~6天</div>
              </router-link>
            </div>
            <div class="category-item-list pull-left">
              <router-link
                class="category-item-link"
                :to="{
                  name: 'CityActivities',
                  query: {
                    cate_id: '',
                    type: 'other',
                    other_type: 'time',
                    days: 7
                  }
                }"
              >
                <div class="category-item-img-wrapper">
                  <img
                    class="category-item-img"
                    src="../../assets/images/day5_5.png"
                  />
                </div>
                <div class="category-item-title">7天以上</div>
              </router-link>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>

      <!-- 发现目的地 -->
      <div class="city-list">
        <div class="city-title text-center">发现目的地</div>
        <yd-tab>
          <yd-tab-panel :label="jingnei.cate_name">
            <div class="city-content">
              <div class="city-content-body">
                <div class="city-item-list">
                  <div
                    class="city-item pull-left"
                    v-for="(cate, index) in jingnei.children"
                    :key="index"
                  >
                    <router-link
                      class="city-link"
                      :to="{
                        name: 'CityActivities',
                        query: { cate_id: cate.id, type: 'jingnei' }
                      }"
                    >
                      <div class="city-box">
                        <div
                          class="city-cover-img"
                          :style="'background-image: url(' + cate.pic + ');'"
                        >
                          <div class="city-name">{{ cate.cate_name }}</div>
                        </div>
                      </div>
                    </router-link>
                  </div>

                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </yd-tab-panel>
          <yd-tab-panel :label="jingwai.cate_name">
            <div class="city-content">
              <div class="city-content-body">
                <div class="city-item-list">
                  <div
                    class="city-item pull-left"
                    v-for="(cate, index) in jingwai.children"
                    :key="index"
                  >
                    <router-link
                      class="city-link"
                      :to="{
                        name: 'CityActivities',
                        query: { cate_id: cate.id, type: 'jingwai' }
                      }"
                    >
                      <div class="city-box">
                        <div
                          class="city-cover-img"
                          :style="'background-image: url(' + cate.pic + ');'"
                        >
                          <div class="city-name">{{ cate.cate_name }}</div>
                        </div>
                      </div>
                    </router-link>
                  </div>

                  <div class="clearfix"></div>
                </div>
              </div>
            </div>
          </yd-tab-panel>
        </yd-tab>
      </div>
    </div>
  </div>
</template>
<script>
// import { getCityList } from "@api/public";
import { getActivityCategory } from "@api/store";
import { Tab, TabPanel } from "vue-ydui/dist/lib.rem/tab";

export default {
  data: function() {
    return {
      cities: [],
      category: [],
      jingwai: [],
      jingnei: []
    };
  },
  components: {
    [Tab.name]: Tab,
    [TabPanel.name]: TabPanel
  },
  mounted: function() {
    let that = this;
    this.$dialog.loading.open();
    getActivityCategory()
      .then(res => {
        that.$set(that, "category", res.data.other);
        that.$set(that, "jingnei", res.data.destination[0]);
        that.$set(that, "jingwai", res.data.destination[1]);
        this.$dialog.loading.close();
      })
      .catch(this.$dialog.loading.close());
  }
};
</script>
<style scoped>
.goods-category {
  background-color: #fff;
}
</style>
